import { useState } from 'react';
import { createMenuPermission } from '../../helpers/api_helper';

const useCreateMenuPermission = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const createMenuPermissionHook = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await createMenuPermission(data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to create menu permission: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { createMenuPermission: createMenuPermissionHook, loading, error };
};

export default useCreateMenuPermission;